import React from "react";
import {Carousel, Container, Image} from "react-bootstrap";

export default class ImageCarousel extends React.Component {
    render() {
        return (
            <div>
                <Container lg>
                    <Carousel>
                        <Carousel.Item>
                            <Image src={"pictures/bathroom1.png"} fluid/>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Image src={"pictures/kitchen1.png"} fluid/>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Image src={"pictures/kitchen2.png"} fluid/>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Image src={"pictures/bathroom2.png"} fluid/>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Image src={"pictures/kitchen3.png"} fluid/>
                        </Carousel.Item>
                    </Carousel>
                </Container>
            </div>
        );
    }
}